<template>
  <b-table
    :id="`incentivesTable`"
    bordered
    :ref="`incentivesTable-${budgetYear.year}`"
    head-variant="light"
    :fields="fields"
    :items="getProductsFromListItems(budgetYear.year, projectIncentivePayments)"
    class="list-item-table"
    show-empty>
    <template v-slot:cell(incentiveType)="row">
      {{ getIncentiveType(row.item) }}
    </template>
    <template v-slot:cell(payee)="row">
      {{ getIncentivePayee(row.item, contactBriefs, organizationBriefs) }}
    </template>
    <template v-slot:cell(fundingSource)="row">
      {{ getIncentiveFundingSource(row.item, fundingSources) }}
    </template>
    <template v-slot:cell(dueDate)="row">
      {{ getIncentiveDueDate(row.item) }}
    </template>
    <template v-slot:cell(paymentAmount)="row">
      {{ getIncentivePaymentAmount(row.item) }}
    </template>
  </b-table>
</template>
<script>
import { mapState } from 'vuex';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';

export default {
  name: 'IncentivePaymentsTable',
  mixins: [ProjectApprovalMembershipManager],
  props: {
    budgetYear: Object,
    projectIncentivePayments: Array,
    getProductsFromListItems: Function,
    contactBriefs: Array,
    organizationBriefs: Array,
    fundingSources: Array,
  },
  data() {
    return {
      fields: [
        {
          key: 'incentiveType',
          label: 'Incentive Type',
          class: 'incentive-type-column',
        },
        {
          key: 'payee',
          label: 'Payee',
          class: 'incentive-payee-column',
        },
        {
          key: 'fundingSource',
          label: 'Funding Source',
          class: 'incentive-fundingsource-column',
        },
        {
          key: 'dueDate',
          label: 'Due Date',
          class: 'incentive-duedate-column',
        },
        {
          key: 'paymentAmount',
          label: 'Payment Amount',
          class: 'incentive-paymentamount-column',
        },
      ],
    };
  },
  computed: {
    ...mapState('Project', {
      priceLists: (state) => state.priceLists,
      products: (state) => state.products,
    }),
  },
  methods: {
    getIncentiveType(item) {
      return item.incentiveType.name;
    },
    getIncentivePayee(item, contactBriefs, organizationBriefs) {
      if (!contactBriefs || contactBriefs.length === 0) return '';
      if (!organizationBriefs || organizationBriefs.length === 0) return '';

      if (item.vendorType === 'Individual Contact') {
        const payee = contactBriefs.filter((x) => x.id === item.payeeId)[0];
        if (payee === undefined) {
          console.error('Unable to find matching Payee with ID of ', item.payeeId);
        }
        return payee?.name ?? 'N/A';
      }

      const payeeOrg = organizationBriefs.filter((x) => x.id === item.payeeOrgId)[0];
      if (payeeOrg === undefined) {
        console.error('Unable to find matching Payee Org with ID of ', item.payeeOrgId);
      }
      return payeeOrg?.name ?? 'N/A';
    },
    getIncentiveFundingSource(item, fundingSources) {
      if (!fundingSources || fundingSources.length === 0) {
        return '';
      }

      const fundingSource = fundingSources.filter((x) => x.recorD_ID === item.fundingSourceId)[0];
      return fundingSource.recorD_NAME;
    },
    getIncentiveDueDate(item) {
      if (item.dateDue && (new Date(item.dateDue) instanceof Date)) {
        return (new Date(item.dateDue)).toLocaleDateString();
      }
      return item.dateDue;
    },
    getIncentivePaymentAmount(item) {
      if (item.amountPaid) {
        return this.$options.filters.toCurrency(item.amountPaid);
      }
      return '';
    },
  },
};
</script>
